import {RequestStatus} from "@/libs/product";
import {i18n} from "@/libs/i18n";

export default {
    state() {
        const statuses = {};
        statuses[RequestStatus.APPROVED] = 'primary';
        statuses[RequestStatus.PARTIALLY_APPROVED] = 'primary';
        statuses[RequestStatus.REPLIED] = 'success';
        statuses[RequestStatus.REJECTED] = 'danger';

        const reply = {
            default: {
                border: 'light',
                bg: 'default',
                alert: 'secondary'
            },
            light: {
                border: 'light',
                bg: 'default',
                alert: 'secondary'
            },
            required: {
                border: 'warning',
                bg: 'default',
                alert: 'warning'
            },
            warning: {
                border: 'warning',
                bg: 'default',
                alert: 'warning'
            },
            success: {
                border: 'success',
                bg: 'default',
                alert: 'secondary'
            }
        };

        const flows = {
            verticalSteps: 'Vertical Steps Flow',
            productCard: 'Product Card Flow',
        };

        const monthTranslation = i18n.t('Component(Text):months');

        return {
            received: {
                badgeVariant: statuses,
                replyVariant: reply,
                flows: flows,
                defaultFlow: flows.verticalSteps,

                receivedRequestFlowSwitcherEnvironments: ['qa', 'dev', 'local', 'uat', 'prd', 'prod']
            },
            sent: {
                badgeVariant: statuses,
                replyVariant: reply
            },
            declarationOfValidityOptions: [
                { month: 6, title: '6 ' + monthTranslation },
                { month: 12, title: '12 ' + monthTranslation },
                { month: 18, title: '18 ' + monthTranslation },
                { month: 24, title: '24 ' + monthTranslation }
            ]
        };
    },

    mutations: {
        setReceivedRequestFlow(state, flow) {
            state.received.defaultFlow = flow;
        }
    },

    getters: {
        declarationOfValidityOptions(state) {
            return state.declarationOfValidityOptions;
        }
    },

    actions: {
        changeReceivedRequestFlow({commit}, flow) {
            commit('setReceivedRequestFlow', flow);
        },

        requestRejected() {

        }
    }
};
